<template>
  <div>
    <b-form-group id="input-group-5" label="Estado" label-for="input-5">
      <b-form-select
        @change="listMotivConfirmation"
        id="input-5"
        v-model="stateSelected"
        :options="optionStatesConfir"
        required
      >
        <b-form-select-option :value="null"
          >Seleccione una opción
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-group id="input-group-6" label="Motivo" label-for="input-6">
      <b-form-select
        id="input-6"
        v-model="motiveSelected"
        :options="optionMotivConfirmation"
        required
      >
        <b-form-select-option :value="null"
          >Seleccione una opción
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-row v-show="stateSelected=='REALIZADA_PARCIAL'">
      <b-col cols="12">
        <label>Fecha Estimada</label>
        <calendar v-model="estimatedDate" />
      </b-col>
    </b-row>
      
    <b-form-group id="input-group-7" label="Observaciones" label-for="input-7">
      <b-form-input
        id="input-7"
        v-model="form.observation"
        placeholder="Ingrese aquí sus observaciones"
        required
      ></b-form-input>
    </b-form-group>
    <b-row>
      <b-col cols="12" class="text-center">
        <b-button @click="confirmarOS" class="btn-orange">
          <font-awesome-icon icon="check-circle" /> Confirmar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import Calendar from "./Calendar.vue";
export default {
  name: "ConfirmarOs",
  props: ["detailId","stateOs"],
  components:{Calendar},
  data() {
    return {
      estimatedDate:"",
      form: { observation: "" },
      stateSelected: null,
      optionMotivConfirmation: [],
      motiveSelected: null,
      optionStatesConfir: [
        { value: "REALIZADA", text: "Realizado" },
        { value: "NO_REALIZADA", text: "No Realizado" },
        { value: "REALIZADA_PARCIAL", text: "Realizado Parcial" },
      ],
      valuesResponseConfirmar: { show: true, message: "", hasError: false },
    };
  },

  computed: {
    ...mapState("module", ["username"]),
  },
  methods: {
    listMotivConfirmation() {
     /* if (this.stateSelected == "REALIZADA") this.form.observation = "OK";
      else this.form.observation = null; */
      let valState ="";
      if(this.stateSelected=="REALIZADA"){
        valState ="REALIZED"
      }
      else if (this.stateSelected=="NO_REALIZADA"){
        valState ="UNREALIZED"
      }
      else if(this.stateSelected=="REALIZADA_PARCIAL"){
        valState ="REALIZED_PARTIAL"
      }
      axios
        .get(
          process.env.VUE_APP_ORDERS_CORE_BASE +
            "/motives?pagination=false&responsible=13&type=" +
            valState
        )
        .then((response) => {
          if (response.data.length > 0) {
            const data = response.data.map((row) => {
              return {
                value: row.id,
                text: row.description,
              };
            });
            this.optionMotivConfirmation = data;
          }
        })
        .catch((error) => console.log(error));
    },
    async confirmarOS() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.post(
          process.env.VUE_APP_ORDER_BUSINESS_BASE + "/confirmations",
          {
            state: this.stateSelected,
            motive: this.motiveSelected,
            observations: this.form.observation,
            childId: this.detailId,
            user: this.username,
            estimatedDate:this.estimatedDate
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        this.valuesResponseConfirmar.message = "Confirmación exitosa";
      } catch (error) {
        console.log(error);
        this.valuesResponseConfirmar.hasError = true;
        this.valuesResponseConfirmar.message = error.response.data.message;
      } finally {
        this.$bvModal.hide("modal-confirmar");
        this.$emit("setResponse", this.valuesResponseConfirmar);
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
};
</script>
<style scoped>
</style>
